import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      invoiceFormData: {
        mode: 'create',
        show: false,
        title: 'Create Invoice',
        headerTitle: 'Create Invoice',
        submitButtonText: 'Create',
        form: null,
        item: null
      }
    }
  },
  computed: {
    ...mapGetters({
      getInvoices: 'finances/getInvoices',
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getStatuses: 'finances/getStatuses',
      getProjects: 'projects/getProjects',
      getTemplates: 'finances/getTemplates',
      getClientsBankDetailsAll: 'finances/getClientsBankDetailsAll',
      getInvoicesTypes: 'finances/getInvoicesTypes',
      getIsModalLoading: 'finances/getIsModalLoading'
    }),
    getActualProjects () {
      const projects = this.getProjects
      // Handle pagination object structure
      const projectsArray = Array.isArray(projects) ? projects : (projects?.data || [])
      return projectsArray.filter(project => project.project_status.name !== 'done')
    }
  },
  methods: {
    fetchInvoiceFormData () {
      return Promise.all([
        this.fetchAllBankDetails(),
        this.fetchInvoicesStatuses(),
        this.fetchProjects(),
        this.fetchAllUsers(),
        this.fetchTemplates(),
        this.fetchInvoicesTypes()
      ])
    },
    async fetchProjects () {
      return this.$api.projects.getProjects()
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    async fetchAllBankDetails () {
      return this.$api.finances.getBankDetailsAll()
    },
    async fetchAllClientBankDetails () {
      return this.$api.finances.getClientsBankDetailsAll()
    },
    async fetchTemplates () {
      return this.$api.finances.getInvoicesTemplate()
    },
    async fetchInvoicesStatuses () {
      return this.$api.finances.getInvoicesStatuses()
    },
    async fetchInvoicesTypes () {
      return this.$api.finances.getInvoicesTypes()
    },
    showCreateInvoices () {
      this.invoiceFormData.mode = 'create'
      this.invoiceFormData.show = true
      this.invoiceFormData.form = null
      this.invoiceFormData.title = 'Details'
      this.invoiceFormData.headerTitle = 'Create Invoice'
      this.invoiceFormData.submitButtonText = 'Create'
    },
    showEditInvoice (data, item) {
      this.invoiceFormData.mode = 'edit'
      this.invoiceFormData.show = true
      this.invoiceFormData.form = data
      this.invoiceFormData.item = item
      this.invoiceFormData.headerTitle = item?.invoice_number ? `Invoice ${item.invoice_number}` : data?.invoice_number ? `Invoice ${data.invoice_number}` : 'Invoice'
      this.invoiceFormData.title = 'Details'
      this.invoiceFormData.submitButtonText = 'Save'
    },
    hideInvoiceForm () {
      this.invoiceFormData.show = false
    },
    async saveInvoice (fields) {
      if (this.invoiceFormData.form && this.invoiceFormData.form.id) {
        const { data } = await this.updateInvoice(fields)
        this.hideInvoiceForm()
        this.invoiceFormData.item = data
      } else {
        const { data } = await this.createInvoice(fields)
        this.hideInvoiceForm()
        this.invoiceFormData.item = data
      }
    },
    prepareDataForEditAndCreateRequest (fields) {
      let newFields = cloneDeep(fields)

      newFields.issue_date.value = this._toLocalTime(newFields.issue_date.value)
      newFields.due_date.value = this._toLocalTime(newFields.due_date.value)
      if (newFields.paid_date) {
        newFields.paid_date.value = this._toLocalTime(newFields.paid_date.value)
      }

      if (fields.invoice_type.value.id === 1) {
        newFields.periods.value = []
        newFields.specialisations.value = []
      }

      if (fields.invoice_type.value.id === 2) {
        newFields.items.value = []
        newFields.specialisations.value = []
      }

      if (fields.invoice_type.value.id === 3) {
        newFields.items.value = []
        newFields.periods.value = []
      }

      if (fields.invoice_type.value.id === 4) {
        newFields.items.value = []
        newFields.periods.value = []
        newFields.specialisations.value = []
      }

      if (newFields.periods.value.length > 0) {
        newFields.periods.value = newFields.periods.value.map(item => {
          return {
            ...item,
            user_id: item.user.id,
            date_from: this._toLocalTime(item.date_from),
            date_to: this._toLocalTime(item.date_to)
          }
        })
      }
      if (newFields.items.value.length > 0) {
        newFields.items.value = newFields.items.value.map(item => {
          return {
            ...item,
            user_id: item.user.id,
            date_from: this._toLocalTime(item.date_from),
            date_to: this._toLocalTime(item.date_to)
          }
        })
      }
      let data = {}

      for (let key in newFields) {
        const field = newFields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        if (value) {
          data[name] = typeof value === 'object' && !(value instanceof Array) ? value[field['valueField']] : value
        }
      }
      if (newFields.auto_fill.value) {
        data['auto_fill'] = newFields.auto_fill.value
      }
      data['custom_file'] = newFields.custom_file.value
      return data
    },
    async validateFields (fields) {
      // Only show zero hourly rate confirmation for "Employee time and material" (ID 1) or "Employee period" (ID 2) invoice types
      const invoiceType = fields.invoice_type.value
      const isEmployeeTimeOrPeriod = invoiceType && (invoiceType.id === 1 || invoiceType.id === 2)
      /* If you're ever going to refactor this code please try to replace loose equality operator with strict equality and remove eslint-disable-next-line comment */
      // eslint-disable-next-line eqeqeq
      if (isEmployeeTimeOrPeriod && fields.items.value && fields.items.value.some(item => item.hour_cost == '0')) {
        const createWithZeroHourCost = await this.$root.$confirm.open(
          '',
          'Some of employees have hourly rate = $0. Are you sure ?'
        )
        return createWithZeroHourCost
      }
      return true
    },
    updateInvoice (fields) {
      return new Promise((resolve, reject) => {
        const data = this.prepareDataForEditAndCreateRequest(fields)
        // this._toggleDataPageLoading(async () => {
        this.$store.dispatch('finances/setIsModalLoading', true)
        this.$api.finances.updateInvoices(data)
          .then(response => {
            this.$snotify.success(
              'Invoice successfully saved',
              'Success',
              this.$store.state.snotify
            )
            resolve(response)
          }, error => {
            // Hook for components to handle backend validation errors
            if (this.handleBackendValidationErrors) {
              this.handleBackendValidationErrors(error)
            }

            this.errorNotifications(error)
            reject(error)
          })
          .finally(() => {
            this.$store.dispatch('finances/setIsModalLoading', false)
          })
        // })
      })
    },
    createInvoice (fields) {
      return new Promise((resolve, reject) => {
        const data = this.prepareDataForEditAndCreateRequest(fields)
        this.$store.dispatch('finances/setIsModalLoading', true)
        this._toggleDataPageLoading(async () => {
          await this.$api.finances.createInvoices(data)
            .then(response => {
              this.$snotify.success(
                'Invoice successfully created',
                'Success',
                this.$store.state.snotify
              )
              resolve(response)
            }, error => {
              // Hook for components to handle backend validation errors
              if (this.handleBackendValidationErrors) {
                this.handleBackendValidationErrors(error)
              }

              this.errorNotifications(error)
              reject(error)
            })
            .finally(() => {
              this.$store.dispatch('finances/setIsModalLoading', false)
            })
        })
      })
    }
  }
}
